import { FC } from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';
import { colors } from '../colors';
import Modal from './base';

interface IDeleteModal {
  deleteTitle: string;
  deleteText: string;
  isLoading?: boolean;
  deleteBtnClick: () => void;
  cancelBtnClick: () => void;
}
export const DeleteModal: FC<IDeleteModal> = ({
  deleteText,
  deleteTitle,
  isLoading,
  deleteBtnClick,
  cancelBtnClick
}) => {
  return (
    <Modal>
      <Container>
        <ModalCard>
          <WarningSymbol>!</WarningSymbol>
          <DeleteTitle>{deleteTitle}</DeleteTitle>
          <DeleteText>{deleteText}</DeleteText>
          <DeleteButtonGroup>
            <ConfirmDeleteButton
              type={'button'}
              disabled={isLoading}
              onClick={deleteBtnClick}
            >
              {!isLoading ? `Yes, Delete` : `Deleting...`}
            </ConfirmDeleteButton>
            <CancelDeleteButton
              disabled={isLoading}
              type={'button'}
              onClick={cancelBtnClick}
            >
              Cancel
            </CancelDeleteButton>
          </DeleteButtonGroup>
        </ModalCard>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  padding: 20px 45px;
  text-align: center;
  max-width: 400px;
  height: 290px;
`;
const ModalCard = styled.div``;

const WarningSymbol = styled.p`
  background-color: ${colors.danger};
  color: ${colors.white};
  border-radius: 50px;
  width: 24px;
  height: 24px;
  font-size: ${pxToRem(20)};
  text-align: center;
  padding: 10px;
  margin: 25px auto;
`;
const DeleteTitle = styled.h5`
  font-weight: 600;
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(25)};
  color: #27272e;
  margin-bottom: 8px;
`;
const DeleteText = styled.p`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(23)};
  color: #425466;
`;
const DeleteButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;
const ConfirmDeleteButton = styled.button`
  border: none;
  background-color: ${colors.danger};
  border-radius: 8px;
  color: ${colors.white};
  padding: 12px 25px;
  font-size: ${pxToRem(14)};
  margin: 0 15px;
`;
const CancelDeleteButton = styled.button`
  border: none;
  background-color: #fafafa;
  border-radius: 8px;
  color: ${colors.black};
  padding: 12px 25px;
  font-size: ${pxToRem(14)};
  margin: 0 15px;
`;
